/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
// tab page
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";
import PartnerInfo from "../../../components/Partner/PartnerInfo";


const Pertner = () => {
  const history = useHistory();
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
    shallowEqual
  );

  const [targetPermission, setTargetPermission] = useState(null);


  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(
        (p) => p.code === "COMPANY_MANAGEMENT"
      );
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "COMPANY_MANAGEMENT");
      }
    }
  }, [permissions]);


  return (
    !isEmpty(targetPermission) && (
      <div className="page-content">
        <PageHeader title={"노출 정보 관리"} />
        <PartnerInfo
          mode={"create"}
        />
      </div>
    )
  );
};

export default Pertner;
